import { z } from 'zod'
import { requestEnvelope } from './client'
import { incidentSchema, paginated, type Incident } from './schemas'
import type { IncidentFilter } from '../lib/query-keys'

export async function listIncidents(f: IncidentFilter) {
  const params = new URLSearchParams({
    status: f.status,
    page: String(f.page),
    pageSize: String(f.pageSize),
  })
  if (f.type) params.set('type', f.type)
  const data = await requestEnvelope(`/incidents?${params.toString()}`, paginated(incidentSchema))
  return data
}

export async function getIncident(id: string): Promise<Incident> {
  return requestEnvelope(`/incidents/${encodeURIComponent(id)}`, incidentSchema)
}

export async function verifyIncident(id: string, status: 'confirmed' | 'rejected'): Promise<void> {
  await requestEnvelope(
    `/incidents/${encodeURIComponent(id)}/verify`,
    z.record(z.string(), z.unknown()),
    {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ status }),
    },
  )
}

export type { Incident }
